import { useEffect, useState } from "react"

import { getListOptions } from "../../Settings/components/settings-lists/list-options.services.ts"

export interface DocumentTypeOption {
  label: string
  value: string
}

/** The company's active Document Type options, shared by every picker so they never drift. */
export function useDocumentTypeOptions(enabled = true) {
  const [options, setOptions] = useState<DocumentTypeOption[]>([])
  const [loadFailed, setLoadFailed] = useState(false)

  useEffect(() => {
    if (!enabled) return
    let cancelled = false
    void getListOptions("document_type").then((response) => {
      if (cancelled) return
      if (!response.ok || !response.data) {
        setLoadFailed(true)
        return
      }
      setLoadFailed(false)
      setOptions(
        response.data.results
          .filter((option) => option.is_active)
          .map((option) => ({ label: option.label, value: option.value }))
      )
    })
    return () => {
      cancelled = true
    }
  }, [enabled])

  return { options, loadFailed }
}
